import styles from './ListTable.module.scss';
import { Tooltip } from '@mui/material';
import cn from 'classnames';

//*** To add an ellipsis, pass minWidth='none' (or hard value) ***

type Props = {
    children: React.ReactNode;
    tip?: string;
    maxWidth?: string;
    minWidth?: string;
    lastItem?: boolean;
    style?: React.CSSProperties;
};

const LTItem = ({ children, tip, maxWidth, minWidth, lastItem = false, style }: Props) => {
    const isStringChild = typeof children === 'string';
    const isNumberChild = typeof children === 'number';
    const itemStyles = cn(lastItem ? styles['last-item'] : styles.item);
    return (
        <>
            {isStringChild ? (
                <Tooltip title={tip ? tip : children}>
                    <span
                        style={{
                            maxWidth: maxWidth ? maxWidth : '',
                            minWidth: minWidth ? minWidth : '',
                            ...style,
                        }}
                        className={itemStyles}
                    >
                        {children}
                    </span>
                </Tooltip>
            ) : isNumberChild ? (
                <Tooltip title={tip ? tip : children.toString()}>
                    <span
                        style={{
                            maxWidth: maxWidth ? maxWidth : '',
                            minWidth: minWidth ? minWidth : '',
                            ...style,
                        }}
                        className={itemStyles}
                    >
                        {children}
                    </span>
                </Tooltip>
            ) : (
                <Tooltip title={tip ? tip : ''}>
                    <span
                        style={{
                            maxWidth: maxWidth ? maxWidth : '',
                            minWidth: minWidth ? minWidth : '',
                            ...style,
                        }}
                        className={itemStyles}
                    >
                        {children}
                    </span>
                </Tooltip>
            )}
        </>
    );
};

export { LTItem };
